/*
 * main
 */
import { i18n } from "./i18n"
import { createRouter, RouterProvider } from "@tanstack/react-router"
import { I18nextProvider } from "react-i18next"

import { StrictMode } from "react"
import ReactDOM from "react-dom/client"
import { registerSW } from "virtual:pwa-register"
import { routeTree } from "./routeTree.gen"

const router = createRouter({ routeTree })

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router
	}
}

const rootElement = document.getElementById("root")!
if (!rootElement.innerHTML) {
	const root = ReactDOM.createRoot(rootElement)
	root.render(
		<StrictMode>
			<I18nextProvider i18n={i18n}>
				<RouterProvider router={router} />
			</I18nextProvider>
		</StrictMode>,
	)
}

if ("serviceWorker" in navigator && !/localhost/.test(window.location.host)) {
	console.debug("Registering service worker")
	const updateSW = registerSW({
		onRegistered: () => {
			console.debug("Service worker registered")
		},
		onRegisterError: (error: any) => {
			console.error("Service worker registration error", error)
		},
		onOfflineReady: () => {
			console.debug("App is offline-ready")
		},
		onNeedRefresh: () => {
			console.debug("Service worker needs to be refreshed")
			updateSW.update()
		},
	})
}
